module.exports = __webpack_public_path__ + "static/media/alert-white.1e0c9dc5.svg";